import React from 'react'
import { browserHistory } from 'react-router'
import auth from '../auth'

const Logout = React.createClass({
  componentDidMount () {
    auth.logout(() => {
      browserHistory.push('/login')
    })
  },

  render () {
    return <p>You are now logged out.</p>
  }
})

export default Logout
